import axios from 'axios';

const baseURL = 'https://thegioicode.com/api'; // https://thegioicode.com

export const urlUpload = `${baseURL}/images/upload`;

const request = axios.create({
    baseURL,
    withCredentials: true,
});

export default request;
